module.exports = __webpack_public_path__ + "static/media/bonk1.3660d2a7.mp3";